import script from "./ai-detail-talk.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-detail-talk.vue?vue&type=script&setup=true&lang=js"

import "./ai-detail-talk.vue?vue&type=style&index=0&id=7a37d24c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a37d24c"]])

export default __exports__